import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _Singleton;
export var Singleton = /*#__PURE__*/function () {
  function Singleton(defaultData) {
    _classCallCheck(this, Singleton);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "data", void 0);
    this.data = defaultData;
  }
  return _createClass(Singleton, [{
    key: "initialize",
    value: function initialize(data) {
      if (data !== undefined) {
        this.data = data;
      }
      this.initialized = true;
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }

    // Simplified instance getter with no parameters
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this._instance) {
        this._instance = new this();
      }
      return this._instance;
    }

    // Optional: clear the instance for testing or reinitialization
  }, {
    key: "clearInstance",
    value: function clearInstance() {
      this._instance = null;
    }
  }]);
}();
_Singleton = Singleton;
_defineProperty(Singleton, "_instance", null);